import styled from "@mui/system/styled";

export const Fieldset = styled("fieldset")(({ theme }) => ({
  border: `1px solid ${theme.palette.grey["400"]}`,
  borderRadius: theme.shape.borderRadius,
  "& legend": {
    color: theme.palette.grey["800"],
    // @ts-ignore
    fontSize: theme.typography.caption.fontSize,
    margin: 0
  },
  margin: 0,
  boxSizing: "border-box",
  minWidth: "100%"
}));
